import { render, staticRenderFns } from "./productOrder.vue?vue&type=template&id=a2732e3a&scoped=true"
import script from "./productOrder.vue?vue&type=script&lang=js"
export * from "./productOrder.vue?vue&type=script&lang=js"
import style0 from "./productOrder.vue?vue&type=style&index=0&id=a2732e3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2732e3a",
  null
  
)

export default component.exports